import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import withImmutablePropsToJS from "with-immutable-props-to-js";

import * as actions from "../../shared/actions";
import { updateQuickViewProduct } from "storefront/features/productGrid/actions";
import { updateSearchProduct } from "storefront/features/search/actions";
import { subscribePusher } from "../utils";
import { updateUserAuctionData } from "storefront/features/shared/components/Header/actions";
import { getUserAuctionData } from "storefront/features/shared/components/Header/selectors";
import {
  getProduct,
  getQuickViewIsOpened,
} from "storefront/features/productGrid/selectors";
import { getActiveAuctions } from "storefront/features/account/selectors";
import { updateCustomerActiveAuction } from "storefront/features/account/actions";
import { getCustomerId } from "storefront/features/shared/components/Header/selectors";

const withPusherSubscription = (WrappedComponent) => {
  class SubscriptionPusher extends PureComponent {
    componentDidMount() {
      this.syncSubscription();
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.quickViewIsOpened !== this.props.quickViewIsOpened ||
        prevProps.product?.bidAuctionId !== this.props.product?.bidAuctionId ||
        prevProps.productData?.bidAuctionId !==
          this.props.productData?.bidAuctionId ||
        prevProps.pusherContext !== this.props.pusherContext
      ) {
        this.syncSubscription();
      }
    }

    componentWillUnmount() {
      this.pusherUnsubscribe();
    }

    shouldSubscribe = (props = this.props) => {
      const {
        product,
        productData,
        quickViewIsOpened,
        pusherContext = WrappedComponent.defaultProps?.pusherContext || "grid",
      } = props;

      if (!product?.bidAuctionId) {
        return false;
      }

      if (pusherContext === "quick-view") {
        return quickViewIsOpened;
      }

      if (
        quickViewIsOpened &&
        productData?.bidAuctionId === product.bidAuctionId
      ) {
        return false;
      }

      return true;
    };

    syncSubscription = () => {
      this.pusherUnsubscribe();

      if (this.shouldSubscribe()) {
        this.pusherSubscribe();
      }
    };

    pusherSubscribe = () => {
      const {
        product,
        updateProduct,
        updateQuickView,
        updateAuctionData,
        userAuctionData,
        updateSearchProduct,
        activeAuctions,
        updateCustomerActiveAuction,
        customerId,
      } = this.props;

      try {
        this.pusherCleanup = subscribePusher({
          product,
          quickViewProduct: this.props.productData,
          updateProduct,
          updateQuickView,
          updateAuctionData,
          userAuctionData,
          updateSearchProduct,
          activeAuctions,
          updateCustomerActiveAuction,
          customerId,
        });
      } catch (err) {
        console.error("Pusher subscription failed", err);
      }
    };

    pusherUnsubscribe = () => {
      try {
        if (this.pusherCleanup) {
          this.pusherCleanup();
          this.pusherCleanup = null;
        }
      } catch (err) {
        console.error("Pusher unsubscribe failed", err);
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return SubscriptionPusher;
};

const mapStateToProps = createStructuredSelector({
  activeAuctions: getActiveAuctions,
  userAuctionData: getUserAuctionData,
  productData: getProduct,
  quickViewIsOpened: getQuickViewIsOpened,
  customerId: getCustomerId,
});

const mapDispatchToProps = (dispatch) => ({
  updateProduct: (product) => {
    dispatch(actions.updateProduct(product));
  },
  updateQuickView: (product) => {
    dispatch(updateQuickViewProduct(product));
  },
  updateAuctionData: (data) => {
    dispatch(updateUserAuctionData(data));
  },
  updateCustomerActiveAuction: (data) => {
    dispatch(updateCustomerActiveAuction(data));
  },
  updateSearchProduct: (product) => {
    dispatch(updateSearchProduct(product));
  },
});

export { withPusherSubscription };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withImmutablePropsToJS,
  withPusherSubscription
);
